import React from 'react';
import Navbar from '../components/NavbarLanding';

const About = () => (
  <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB]">
     <Navbar />
    <section className="w-full max-w-7xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-blue-700 text-center">About Us</h2>
        <p className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
          We are passionate about building AI-powered solutions that enhance user experiences and drive innovation. Our platform leverages the latest in artificial intelligence to deliver personalized, engaging, and effective digital interactions.
        </p>
      </div>
    </section>
  </div>
);

export default About; 